
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/blog/post/[slug]",
      function () {
        return require("private-next-pages/en/blog/post/[slug].ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/blog/post/[slug]"])
      });
    }
  